<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
        label-width="200px" :rules="rules">
        <!-- id自动生成uuid -->

        <el-row>
          <el-col :span="12">
            <el-form-item label="名称" prop="name">
              <el-input v-model="formParameter.name" autocomplete="off" :disabled="isDisabled"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="副标题" prop="sname"><el-input v-model="formParameter.sname" :disabled="isDisabled"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="底栏描述" prop="remark">
              <el-input v-model="formParameter.remark" autocomplete="off"
                :disabled="isDisabled"></el-input></el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="状态" prop="state">
              <el-select v-model="formParameter.state" clearable placeholder="请选择状态" @click="ChangeState()">
                <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value"
                  :disabled="isDisabled">
                </el-option> </el-select></el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="类型" prop="type"><el-select v-model="formParameter.type" clearable placeholder="请选择试题类型"
                @change="ChangeType()">
                <el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value"
                  :disabled="isDisabled">
                </el-option> </el-select></el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="排序" prop="sort"><el-input v-model="formParameter.sort" autocomplete="off"
                :disabled="isDisabled"></el-input></el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="精选推介" prop="type">
              <el-checkbox v-model="isJinxuan">精选题库</el-checkbox>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="精选排序" v-if="isJinxuan" prop="popIdx"><el-input v-model="formParameter.popIdx"
                autocomplete="off" :disabled="isDisabled"></el-input></el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="logoUrl" prop="logeUrl">

              <imageUpload v-model="formParameter.logoUrl" model="fileSystem" uri="/statics/logo"
                @change="callBacklogoUrl" :size="1024" :disabled="isDisabled">
              </imageUpload>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="PDFurl" prop="url" v-if="showUpload">
              <file-upload v-model="formParameter.url" model="fileSystem" uri="/statics/pdf" @change="callBack2"
                :size="8132" :disabled="isDisabled" v-if="showUpload">
              </file-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/online/kinds/kinds.js";
import fileUpload from "@/components/biz/fileUpload/fileUpload.vue";
import imageUpload from "@/components/biz/imageUpload/imageUpload.vue";
import constant from "@/util/constant.js";


export default {
  name: "edit",
  components: {
    popup,
    fileUpload,
    imageUpload,
  },
  props: {},
  data() {
    return {
      BASEURL: constant.serverUrl,
      url: "",
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},
      showUpload: false, // 上传pdf按钮禁用
      fileValue: "", //上传后logo的名称
      pdfValue: "", //pdf上传后的名称
      isDisabled: false, //禁用状态（添加分类时达到最大层数）
      kid: "",
      isJinxuan: false, //是否精选

      defaultPid: "0",
      status: [
        {
          value: "1",
          label: "可用",
        },
        {
          value: "2",
          label: "不可用",
        },
      ],
      types: [
        {
          value: "1",
          label: "精选面试题",
        },
        {
          value: "2",
          label: "大厂面试题",
        },
      ],
      //选择父类
      kinds: [],
      rules: {
        //二级排序
        sort: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
        //分类父标题
        name: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 32,
            trigger: "blur",
          },
        ],
        //分类子标题
        sname: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 32,
            trigger: "blur",
          },
        ],
        //描述（底栏）
        remark: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
        //类型：1.精选面试题，2.大厂面试题
        type: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],

        //状态，1：可用，2不可用
        state: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    //上传logo
    callBacklogoUrl(fname) {
      if (fname) {
        this.formParameter.logoUrl = this.BASEURL + fname.substring(fname.lastIndexOf("/statics/logo"));
      }
    },
    //上传pdf
    callBack2(pdfname) {
      console.log("pdfname  =  "+ pdfname)
      if (pdfname) {
        this.formParameter.url = this.BASEURL + pdfname.substring(pdfname.lastIndexOf("/statics/pdf"));
      }
    },
    //获取监听信息
    //打开弹框
    open(parameter, title, disabled, size) {

      if (parameter) {
        this.parameter = parameter.parameter;
        //判定是否精选，回显精选选择框
        if (this.parameter.popIdx) {
          this.isJinxuan = true;
        }

        // this.isDisabled = parameter.parameter.disabled;

        this.$refs.popup.open(title, size);
        this.$nextTick(() => {
          this.init();
        });
      } else {
        this.$refs.popup.open(title, size);
      }
    },
    //关闭弹框
    close() {
      this.isJinxuan = false;
      this.disabled = false;
      this.formParameter = {}
      this.$refs.popup.close();
    },
    ChangeType() {
      if (this.formParameter.type == 1) {
        this.showUpload = false;
      } else {
        this.showUpload = true;
      }
    },
    ChangeState() {
      console.log("state   " + this.formParameter.state);
    },

    //提交表单
    confirm() {
     // console.log("提交中");

      //console.log("this.formParameter.type", this.formParameter.type);

      if (!this.isJinxuan) {
      //  console.log("取消精选");

        this.formParameter.popIdx = "";
      }

      let param = null;

      if (this.formParameter.id) {
     //   console.log("type类型", this.formParameter.type);

        param = {
          id: this.formParameter.id,
          type: this.formParameter.type == "精选面试题" ? 1 : 2,
          popIdx: this.formParameter.popIdx,
        };
      } else {
        param = {
          type: this.formParameter.type,
          popIdx: this.formParameter.popIdx,
        };
      }

      if (
        this.formParameter.popIdx != undefined &&
        this.formParameter.popIdx != ""
      ) {
        api.jjIdxInuse(
          param,
          (res) => {
            this.$utils.checkForm(this.$refs.form, () => {
              console.log("this.parameter.id", this.parameter.id);

              this.confirmLoading = false;

              // 添加
              if (this.parameter.id == "") {
                console.log("提交ing");
                if (this.parameter.id != undefined) {
                  this.formParameter.pid = this.parameter.id;
                } else {
                  this.formParameter.pid = 1;
                }
                this.formParameter.pname = this.parameter.name;
                let parameter = this.$utils.merger(this.formParameter);
                console.log(parameter);

                api.save(
                  parameter,
                  (response) => {
                    this.$utils.msg.success(response.msg);
                    this.confirmLoading = false;
                    this.close();
                    this.$parent.list();
                  },
                  (response) => {
                    this.$utils.msg.warning(response.msg);
                    this.confirmLoading = false;
                  }
                );
              } else {
                // 修改
                if (this.formParameter.type == "精选面试题") {
                  this.formParameter.type = 1;
                }
                if (this.formParameter.type == "大厂面试题") {
                  this.formParameter.type = 2;
                }
                if (this.formParameter.state == "可用") {
                  this.formParameter.state = 1;
                }
                if (this.formParameter.state == "不可用") {
                  this.formParameter.state = 2;
                }
                console.log(this.formParameter);
                let parameter = this.$utils.merger(this.formParameter);
                console.log("update");

                api.update(
                  parameter,
                  (response) => {
                    this.$utils.msg.success(response.msg);
                    this.confirmLoading = false;
                    this.close();
                    this.$parent.list();
                  },
                  (response) => {
                    this.$utils.msg.warning(response.msg);
                    this.confirmLoading = false;
                  }
                );
              }
            });
          }
          // (err) => {
          //   this.$utils.msg.warning("该序号已占用");
          // }
        );
      } else {
        this.$utils.checkForm(this.$refs.form, () => {
          this.confirmLoading = false;
          // 添加
          if (this.parameter.id == "") {
          //  console.log("提交ing");
            if (this.parameter.id != undefined) {
              this.formParameter.pid = this.parameter.id;
            } else {
              this.formParameter.pid = 1;
            }
            this.formParameter.pname = this.parameter.name;
            let parameter = this.$utils.merger(this.formParameter);
          //  console.log(parameter);

            api.save(
              parameter,
              (response) => {
                this.$utils.msg.success(response.msg);
                this.confirmLoading = false;
                this.close();
                this.$parent.list();
              },
              (response) => {
                this.$utils.msg.warning(response.msg);
                this.confirmLoading = false;
              }
            );
          } else {
            // 修改
            if (this.formParameter.type == "精选面试题") {
              this.formParameter.type = 1;
            }
            if (this.formParameter.type == "大厂面试题") {
              this.formParameter.type = 2;
            }
            if (this.formParameter.state == "可用") {
              this.formParameter.state = 1;
            }
            if (this.formParameter.state == "不可用") {
              this.formParameter.state = 2;
            }
            //console.log(this.formParameter);
            let parameter = this.$utils.merger(this.formParameter);
             // console.log("update");

            api.update(
              parameter,
              (response) => {
                this.$utils.msg.success(response.msg);
                this.confirmLoading = false;
                this.close();
                this.$parent.list();
              },
              (response) => {
                this.$utils.msg.warning(response.msg);
                this.confirmLoading = false;
              }
            );
          }
        });
      }
    },
    init() {
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = {};
      // this.fileUpload.fileList = [];
      //清楚校验
      this.$refs.form.clearValidate();
      if (this.parameter.type == 1) {
        this.parameter.type = "精选面试题";
        this.showUpload = false;
        console.log(this.showUpload);
      }
      if (this.parameter.type == 2) {
        this.parameter.type = "大厂面试题";
        this.showUpload = true;
        console.log(this.showUpload);
      }
      if (this.parameter.state == 1) {
        this.parameter.state = "可用";
      }
      if (this.parameter.state == 2) {
        this.parameter.state = "不可用";
      }
      if (this.parameter.id) {
        //编辑查询数据
        this.formParameter = this.parameter;

        this.formParameter.logoUrl = this.BASEURL + this.parameter.logoUrl;

        this.popupLoading = false;
      } else {
        //添加
        this.popupLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
